
/**
 * import中的webpackChunkName，为按需加载生成的JS名称，请使用 [project-name]-[module-name]，示例如下
 */
export default [
  {
    path: '/sop/sop_list',
    name:'/sop/sop_list',
    meta:{
        title:'SOP管理'
    },
    component: () =>
        import ( /* webpackChunkName: "example-sop" */ '../views/sop/sop_list.vue')
  },
  {
    path: '/sop/sop_detail',
    name:'/sop/sop_detail',
    meta:{
        title:'SOP详情'
    },
    component: () =>
        import ( /* webpackChunkName: "example-sop" */ '../views/sop/sop_detail.vue')
  },
]